import React, { useCallback, useEffect, useState } from "react";
import { Alert, Box, Button } from "@intech/web-ui";
import { LoadingComponent, MasterPage } from "@components";
import { ProtocoloPWEntidade } from "@entidades";
import { ComprovantesService } from "@services";
import { FaSearch } from "react-icons/fa";
import { useHistory } from "react-router";
import { DateFix } from "@helpers";

export { Detalhe } from "./Detalhes";

export const Comprovantes: React.FC = ({ ...rest }) => {
  const history = useHistory();

  const [Loading, setLoading] = useState(false);
  const [Erro, setErro] = useState<string>("");

  const [ListaComprovantes, setListaComprovantes] = useState<ProtocoloPWEntidade[]>([]);

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        let lista = await ComprovantesService.Buscar();
        setListaComprovantes(lista);
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const selecionarCorSituacao = useCallback((situacao: string) => {
    switch (situacao) {
      case "RECUSADO": return "danger";
      case "EFETIVADO": return "success";
      case "SOLICITADO": return "info";
      default: return "warning";
    }
  }, []);

  return (
    <MasterPage {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && ListaComprovantes.length === 0 && <Alert type={"info"}>{"Você não possui comprovantes para consulta."}</Alert>}

      {!Loading && !Erro && ListaComprovantes.length > 0 && (
        <Box>
          <div className={"table-responsive"}>
            <table className={"table table-striped"}>
              <thead>
                <tr>
                  <th>{"Data Solicitação"}</th>
                  <th>{"Funcionalidade"}</th>
                  <th>{"Protocolo"}</th>
                  <th>{"Situação"}</th>
                  <th>{"Data Efetivação"}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {ListaComprovantes.map((comprovante, index) => (
                  <tr key={index}>
                    <td>{DateFix(comprovante.DTA_SOLICITACAO)}</td>
                    <td>{comprovante.DES_FUNCIONALIDADE}</td>
                    <td>{comprovante.COD_IDENTIFICADOR}</td>
                    <td>
                      <strong>
                        {<span className={`text-${selecionarCorSituacao(comprovante.DES_SITUACAO)}`}>{comprovante.DES_SITUACAO}</span>}
                      </strong>
                    </td>
                    <td>{DateFix(comprovante.DTA_EFETIVACAO)}</td>
                    <td>
                      <Button
                        type="primary"
                        title="Detalhar"
                        icon={<FaSearch />}
                        onClick={() => history.push(`/comprovantesDetalhe/${comprovante.OID_PROTOCOLO_PW}`)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Box>
      )}
    </MasterPage>
  );
};
